import { ProductV2 } from "./productv2.model";

export class AtomicProductV2 extends ProductV2 {
    status: string;
    replacementPrice: string;
    pcc: string;
    pccType: string;
}
